import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';
import { ISportButtonEventFilterParams, ISportButtonEventProps } from './types';

const ENDPOINT = '/v1/sport-button-events';

const formatApiError = (error: any): Error => new Error(toUserMessage(error));

export const getSportButtonEventsAsync = async (
  pagination: IPaginationParams,
  filter: ISportButtonEventFilterParams,
): Promise<ISportButtonEventProps[]> => {
  try {
    const response = await api.get(ENDPOINT, { params: { ...pagination, ...filter } });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getSportButtonEventsCountAsync = async (
  filter: ISportButtonEventFilterParams,
): Promise<number> => {
  try {
    const response = await api.get(`${ENDPOINT}/count`, { params: filter });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const resendSportButtonEventAsync = async (id: number): Promise<ISportButtonEventProps> => {
  try {
    const response = await api.post(`${ENDPOINT}/${id}/resend`);
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export interface IResendBulkJobResponse {
  jobId: number;
  hangfireJobId?: string | null;
  message: string;
}

// Reenvio em lote roda em background (lotes de 10 a cada 2min, pra não sobrecarregar a API de
// esportes) — retorna só o id do job, o progresso é acompanhado via useJobQuery(jobId).
export const resendSportButtonEventsBulkAsync = async (
  ids: number[],
): Promise<IResendBulkJobResponse> => {
  try {
    const response = await api.post(`${ENDPOINT}/resend-bulk`, { ids });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};
